import type { Audience } from '@/lib/auth/roles';

/** Each of the three apps has its own sidebar identity so you always know which one you are in. */
export interface ShellTheme {
  sidebar: string;
  brandText: string;
  /** The small role chip next to the wordmark. */
  chip: string;
  chipLabel: string;
  groupLabel: string;
  divider: string;
  item: string;
  itemActive: string;
  userCard: string;
  userMuted: string;
  toggle: string;
  logoFill: string;
  logoGlyph: string;
}

export const shellThemes: Record<Audience, ShellTheme> = {
  owner: {
    sidebar: 'bg-amethyst-900 text-white',
    brandText: 'text-white',
    chip: 'bg-white/15 text-amethyst-100',
    chipLabel: 'Owner',
    groupLabel: 'text-amethyst-300/70',
    divider: 'border-white/10',
    item: 'text-amethyst-100/80 hover:bg-white/10 hover:text-white',
    itemActive: 'bg-white/15 text-white shadow-[inset_2px_0_0_0_#C4B5FD]',
    userCard: 'hover:bg-white/10',
    userMuted: 'text-amethyst-200/70',
    toggle: 'text-amethyst-200 hover:bg-white/10 hover:text-white',
    logoFill: '#FFFFFF',
    logoGlyph: '#2A0049',
  },
  tenant: {
    sidebar: 'bg-white text-slate-900 border-r border-slate-200',
    brandText: 'text-slate-900',
    chip: 'bg-amethyst-50 text-amethyst-800',
    chipLabel: 'Resident',
    groupLabel: 'text-slate-400',
    divider: 'border-slate-100',
    item: 'text-slate-600 hover:bg-slate-100 hover:text-slate-900',
    itemActive: 'bg-amethyst-50 text-amethyst-800 shadow-[inset_2px_0_0_0_#4B0082]',
    userCard: 'hover:bg-slate-100',
    userMuted: 'text-slate-500',
    toggle: 'text-slate-500 hover:bg-slate-100 hover:text-slate-900',
    logoFill: '#4B0082',
    logoGlyph: '#FFFFFF',
  },
  internal: {
    sidebar: 'bg-slate-950 text-white',
    brandText: 'text-white',
    chip: 'bg-amethyst-500/25 text-amethyst-200',
    chipLabel: 'Internal',
    groupLabel: 'text-slate-500',
    divider: 'border-white/10',
    item: 'text-slate-400 hover:bg-white/5 hover:text-white',
    itemActive: 'bg-white/10 text-white shadow-[inset_2px_0_0_0_#A78BFA]',
    userCard: 'hover:bg-white/5',
    userMuted: 'text-slate-400',
    toggle: 'text-slate-400 hover:bg-white/10 hover:text-white',
    logoFill: '#6A5ACD',
    logoGlyph: '#FFFFFF',
  },
};
